/* MHSys Geschenkefinder (Roadmap 3.24) - Zustand, Abruf der Treffer, Bonus-Sortierung, Teilen.
 * Kein Framework, keine Bibliothek (docs/konzept_geschenkefinder.md 5.1/5.2). Ziel < 6 KB.
 * Ohne dieses Skript bleibt sections/mhsys-geschenkefinder.liquid beim <noscript>-Linklisten-Zustand -
 * hier wird der eigentliche interaktive Teil (data-mhsys-finder-schritte) erst sichtbar gemacht.
 */
(() => {
  'use strict';

  const SPEICHER = 'mhsysFinder';
  const KLICKS = 'mhsysFinderKlicks';
  const KLICKS_WEIHNACHTEN = 'mhsysFinderKlicksWeihnachten';
  const MINUTEN30 = 30 * 60 * 1000;

  // Fuer Tuva/Paket C (_quelle geschenkefinder vs. geschenkefinder-weihnachten): welcher Finder
  // das ist, kommt aus der zugewiesenen Seiten-Vorlage (data-vorlage = template.suffix), nicht aus
  // der URL - der Inhaber kann die Seiten-Adresse frei waehlen, die Vorlage bleibt das verlaessliche
  // Merkmal.
  function istWeihnachtsFinder(wurzel) {
    return wurzel.dataset.vorlage === 'weihnachtsgeschenke-finder';
  }

  function klickMerken(schluessel, handle) {
    try {
      const liste = JSON.parse(sessionStorage.getItem(schluessel) || '[]');
      if (handle && !liste.includes(handle)) { liste.push(handle); sessionStorage.setItem(schluessel, JSON.stringify(liste.slice(-20))); }
    } catch (e) {}
  }

  function melden(schritt, antwort) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('mhsys_geschenkefinder', { schritt, antwort });
      }
    } catch (e) {}
  }

  /* Nutzung fuer mhsys (Roadmap 6.48, mhsys docs/module/geschenkefinder.md): je Seite hoechstens einmal "start" und einmal
     "ergebnis" an den Kundeninhalte-Proxy, ohne Kunde und ohne Antworten - nichts wartet auf die Antwort, Fehler bleiben still.
     Frueher als 350 ms nach dem Laden nimmt mhsys nichts an (_dauer). Im Theme-Editor nicht. */
  const gezaehlt = new Set();
  function zaehlen(wurzel, schritt) {
    const finder = istWeihnachtsFinder(wurzel) ? 'geschenkefinder-weihnachten' : 'geschenkefinder';
    if (gezaehlt.has(finder + schritt) || (window.Shopify && window.Shopify.designMode)) return;
    gezaehlt.add(finder + schritt);
    const senden = () =>
      fetch('/apps/kunde?bereich=finder', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ finder, schritt, _dauer: Math.round(performance.now()) }),
        credentials: 'same-origin',
        keepalive: true,
      }).catch(() => {});
    const warten = 350 - performance.now();
    if (warten > 0) setTimeout(senden, warten);
    else senden();
  }

  function init(wurzel) {
    const start = wurzel.querySelector('[data-mhsys-finder-start]');
    const startTitel = wurzel.querySelector('.mhsys-finder__titel');
    const schritteBox = wurzel.querySelector('[data-mhsys-finder-schritte]');
    const zwischen = wurzel.querySelector('[data-mhsys-finder-zwischen]');
    const ergebnisBox = wurzel.querySelector('[data-mhsys-finder-ergebnis]');
    const fehlerBox = wurzel.querySelector('[data-mhsys-finder-fehler]');
    const balken = wurzel.querySelector('[data-mhsys-finder-balken]');
    const statusZeile = wurzel.querySelector('[data-mhsys-finder-status]');
    const zurueckKnopf = wurzel.querySelector('[data-mhsys-finder-zurueck]');
    const fieldsets = [...wurzel.querySelectorAll('[data-mhsys-finder-frage]')];
    const treffer = wurzel.querySelector('[data-mhsys-finder-treffer]');
    const gutscheinVorlage = wurzel.querySelector('[data-mhsys-finder-gutschein]');
    const ergTitel = wurzel.querySelector('[data-mhsys-finder-ergebnis-titel]');
    const ergSatz = wurzel.querySelector('[data-mhsys-finder-ergebnis-satz]');
    const lockernHinweis = wurzel.querySelector('[data-mhsys-finder-lockern]');
    const b2bErgebnis = wurzel.querySelector('[data-mhsys-finder-b2b-ergebnis]');
    const statusLive = wurzel.querySelector('[data-mhsys-finder-status-live]');
    const fallbackUrl = wurzel.querySelector('[data-mhsys-finder-fehler-link]');

    let antworten = {}; // {1: HTMLInputElement, ...}
    let ueberspringeDrei = false;
    let vorlage = null; // {inhalt: HTMLElement, gesamt: number, kern: string}
    let vorladenLauf = null;
    const direkt = wurzel.classList.contains('mhsys-finder--direkt');

    function reihenfolge() {
      return ueberspringeDrei ? [1, 2, 4] : [1, 2, 3, 4];
    }

    /* „Direkt los“ (Inhaber 03.11.2026): Kopf und erste Frage stehen zusammen, ohne Start-Knopf. Es sind dieselben
       Felder wie sonst, die Antwort läuft über antwortGewaehlt(). Abgewählt, damit dieselbe Antwort wieder auslöst. */
    function einstiegZeigen() {
      wurzel.classList.add('ist-einstieg');
      start.hidden = false;
      schritteBox.hidden = false;
      ergebnisBox.hidden = true;
      zurueckKnopf.hidden = true;
      fieldsets.forEach((fs) => {
        fs.hidden = fs.dataset.mhsysFinderFrage != 1;
      });
      fieldsets[0].querySelectorAll('[data-mhsys-finder-antwort]').forEach((f) => { f.checked = false; });
    }

    function rendereFrage(nr) {
      fieldsets.forEach((fs) => {
        fs.hidden = fs.dataset.mhsysFinderFrage != nr;
      });
      const folge = reihenfolge();
      const pos = folge.indexOf(nr) + 1;
      statusZeile.textContent = `Frage ${pos} von ${folge.length}`;
      balken.style.width = `${(pos / folge.length) * 100}%`;
      zurueckKnopf.hidden = pos <= 1;
      const legende = fieldsets.find((fs) => fs.dataset.mhsysFinderFrage == nr).querySelector('legend');
      legende.focus({ preventScroll: false });
    }

    /* Neue Frage per Klick: rendert UND legt einen Verlaufseintrag an (Browser-Zurueck geht dann
       eine Frage zurueck). Bei popstate (unten) nur rendereFrage() - sonst wuerde jeder Rueckschritt
       selbst wieder einen Vorwaertseintrag anlegen und "Zurueck" ginge nie wirklich zurueck. */
    function zeigeFrage(nr) {
      rendereFrage(nr);
      history.pushState({ mhsysFinderFrage: nr }, '', location.pathname + location.search);
    }

    function bonusListe() {
      const b = new Set();
      [1, 2].forEach((n) => {
        const el = antworten[n];
        if (el && el.dataset.bonus) el.dataset.bonus.split(',').forEach((h) => b.add(h));
      });
      return b;
    }

    async function hole(kernHandle, von, bis) {
      let url = `/collections/${kernHandle}?section_id=mhsys-geschenkefinder-treffer&sort_by=best-selling&filter.v.availability=1`;
      if (von) url += `&filter.v.price.gte=${von}`;
      if (bis) url += `&filter.v.price.lte=${bis}`;
      const r = await fetch(url);
      if (!r.ok) throw new Error('finder-abruf');
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inhalt = doc.querySelector('[data-mhsys-finder-treffer-inhalt]');
      return { inhalt, gesamt: inhalt ? Number(inhalt.dataset.gesamt || 0) : 0, kern: kernHandle };
    }

    function vorladen(kernHandle) {
      vorladenLauf = hole(kernHandle, null, null).then((r) => { vorlage = r; }).catch(() => {});
    }

    function preisPasst(kachel, von, bis) {
      const p = Number(kachel.dataset.preis || 0);
      if (von && p < von * 1) return false;
      if (bis && p > bis * 1) return false;
      return true;
    }

    function sortiereUndZeige(container, bonusSet) {
      const kacheln = [...container.querySelectorAll('.mhsys-kachel')];
      kacheln.forEach((k, i) => { k.dataset.mhsysReihe = i; });
      kacheln.sort((a, b) => {
        const wa = (a.dataset.koll || '').split(',').filter((h) => bonusSet.has(h)).length;
        const wb = (b.dataset.koll || '').split(',').filter((h) => bonusSet.has(h)).length;
        if (wa !== wb) return wb - wa;
        return a.dataset.mhsysReihe - b.dataset.mhsysReihe;
      });
      const anzahl = kacheln.length;
      const gekuerzt = kacheln.slice(0, 12);
      // Wunsch Inhaber (21.09.2026): B2B-Kachel an 5. Stelle im Ergebnis (Index 4), bei weniger als
      // 5 Treffern ans Ende - derselbe Baustein wird hier nur umgehaengt, nie geklont.
      if (b2bErgebnis) gekuerzt.splice(Math.min(4, gekuerzt.length), 0, b2bErgebnis);
      treffer.replaceChildren();
      gekuerzt.forEach((k) => treffer.appendChild(k));
      if (gutscheinVorlage) treffer.appendChild(gutscheinVorlage.content.cloneNode(true));
      return anzahl;
    }

    /* ausSpeicher: das Ergebnis kommt aus dem Tab-Speicher zurueck (Neuladen) - das zaehlt nicht noch einmal als Nutzung */
    async function ergebnisZeigen(ausSpeicher = false) {
      const von = antworten[4] ? antworten[4].dataset.preisVon : null;
      const bis = antworten[4] ? antworten[4].dataset.preisBis : null;
      const kern = ueberspringeDrei ? antworten[1].dataset.kern : antworten[3].dataset.kern;
      const bonus = bonusListe();
      let gelockert = false;

      schritteBox.hidden = true;
      zwischen.hidden = false;

      try {
        if (vorladenLauf) await vorladenLauf;
        let treffermenge = null;

        // Vorgeladenes Ergebnis (ohne Preis) im Browser filtern - spart die meisten zweiten Abrufe.
        if (vorlage && vorlage.kern === kern) {
          const passend = [...vorlage.inhalt.querySelectorAll('.mhsys-kachel')].filter((k) => preisPasst(k, von, bis));
          if (passend.length >= 6) {
            const box = document.createElement('div');
            passend.forEach((k) => box.appendChild(k.cloneNode(true)));
            treffermenge = box;
          }
        }

        // Lockern in drei Stufen (Konzept Abschnitt 4), erst wenn die Vorlage nicht reicht:
        // (1) derselbe Kern ohne Preisfilter, (2) Bonus-Kollektion aus Frage 1 als Kern,
        // (3) die Ausweich-Kollektion. Jede Stufe eine echte Abfrage, nie eine leere Seite.
        if (!treffermenge) {
          const r1 = await hole(kern, von, bis);
          if (r1.gesamt >= 6) {
            treffermenge = r1.inhalt;
          } else {
            gelockert = true;
            const r2 = await hole(kern, null, null);
            let bester = r2;
            if (r2.gesamt < 6) {
              const bonusKern = antworten[1].dataset.bonus ? antworten[1].dataset.bonus.split(',')[0] : null;
              if (bonusKern) {
                let r3 = await hole(bonusKern, von, bis);
                if (r3.gesamt < 6) r3 = await hole(bonusKern, null, null);
                if (r3.gesamt > bester.gesamt) bester = r3;
              }
              if (bester.gesamt < 6 && wurzel.dataset.fallback && wurzel.dataset.fallback !== kern) {
                const r4 = await hole(wurzel.dataset.fallback, null, null);
                if (r4.gesamt > bester.gesamt) bester = r4;
              }
            }
            treffermenge = bester.inhalt;
          }
        }
        const anzahl = sortiereUndZeige(treffermenge, bonus);
        const pronomen = (antworten[1] && antworten[1].dataset.pronomen) || 'dir';
        ergTitel.textContent = (wurzel.dataset.ergebnisTitel || 'Des kannt %p% gfoin!').replace('%p%', pronomen);
        ergSatz.textContent = [1, 2, 3, 4]
          .map((n) => (antworten[n] ? antworten[n].parentElement.querySelector('.mhsys-finder__antwort-bai').textContent : ''))
          .filter(Boolean)
          .join(' · ');
        lockernHinweis.hidden = !gelockert;
        statusLive.textContent = `${anzahl > 12 ? 12 : anzahl} Geschenke gefunden`;
        if (fallbackUrl) fallbackUrl.href = `/collections/${kern}`;
        melden('ergebnis', String(anzahl));
        if (!ausSpeicher) zaehlen(wurzel, 'ergebnis');
        zwischen.hidden = true;
        ergebnisBox.hidden = false;
        ergTitel.focus();
        speichern();
      } catch (e) {
        zwischen.hidden = true;
        fehlerBox.hidden = false;
      }
    }

    function speichern() {
      try {
        const daten = { ts: Date.now(), kuerzel: [1, 2, 3, 4].map((n) => antworten[n] ? antworten[n].dataset.kuerzel : '') };
        sessionStorage.setItem(SPEICHER, JSON.stringify(daten));
      } catch (e) {}
    }

    function antwortGewaehlt(nr, feld) {
      if (direkt && nr === 1) {
        wurzel.classList.remove('ist-einstieg');
        start.hidden = true;
        melden('start', '');
        zaehlen(wurzel, 'start');
      }
      antworten[nr] = feld;
      melden(String(nr), feld.dataset.kuerzel);
      speichern();
      if (nr === 1) {
        ueberspringeDrei = !!feld.dataset.kern;
        if (ueberspringeDrei) vorladen(feld.dataset.kern);
      }
      if (nr === 3) vorladen(feld.dataset.kern);
      const folge = reihenfolge();
      const naechste = folge[folge.indexOf(nr) + 1];
      if (naechste) zeigeFrage(naechste); else ergebnisZeigen();
    }

    wurzel.querySelectorAll('[data-mhsys-finder-antwort]').forEach((feld) => {
      feld.addEventListener('change', () => {
        antwortGewaehlt(Number(feld.closest('[data-mhsys-finder-frage]').dataset.mhsysFinderFrage), feld);
      });
    });

    const losKnopf = wurzel.querySelector('[data-mhsys-finder-los]');
    if (losKnopf) losKnopf.addEventListener('click', () => {
      start.hidden = true;
      schritteBox.hidden = false;
      melden('start', '');
      zaehlen(wurzel, 'start');
      zeigeFrage(1);
    });

    zurueckKnopf.addEventListener('click', () => history.back());
    window.addEventListener('popstate', (e) => {
      // Schnellansicht (3.25) bzw. Grusskarten-Overlay schliessen bei diesem Zurueck nur ihr Overlay
      if (e.state && (e.state.mhsysSchnellansichtBasis || e.state.mhsysOverlayBasis)) return;
      const nr = e.state && e.state.mhsysFinderFrage;
      if (nr) {
        schritteBox.hidden = false;
        ergebnisBox.hidden = true;
        if (direkt) { wurzel.classList.remove('ist-einstieg'); start.hidden = true; }
        rendereFrage(nr);
        /* Beim Zurueck abwaehlen: ein schon gewaehltes Feld loest beim erneuten Tippen kein change aus */
        fieldsets.find((fs) => fs.dataset.mhsysFinderFrage == nr).querySelectorAll('[data-mhsys-finder-antwort]').forEach((f) => { f.checked = false; });
      } else if (direkt) {
        einstiegZeigen();
      } else {
        schritteBox.hidden = true;
        ergebnisBox.hidden = true;
        start.hidden = false;
      }
    });

    wurzel.querySelectorAll('[data-mhsys-finder-nomoi], [data-mhsys-finder-fehler-nomoi]').forEach((k) => {
      k.addEventListener('click', () => {
        antworten = {};
        ueberspringeDrei = false;
        vorlage = null;
        ergebnisBox.hidden = true;
        fehlerBox.hidden = true;
        try { sessionStorage.removeItem(SPEICHER); } catch (e) {}
        history.pushState(null, '', location.pathname);
        start.hidden = false;
        schritteBox.hidden = true;
        wurzel.querySelectorAll('[data-mhsys-finder-antwort]').forEach((f) => { f.checked = false; });
        if (direkt) einstiegZeigen();
        // Wunsch des Inhabers (21.09.2026): nach "Nomoi!" steht sonst weiter unten auf der Seite,
        // wo vorher das Ergebnis war - zurueck zum Anfang des Finders scrollen (nicht ganz nach
        // oben, falls die Section nicht als erste auf der Seite steht) und den Start-Titel fokussieren.
        const reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        wurzel.scrollIntoView({ block: 'start', behavior: reduziert ? 'auto' : 'smooth' });
        if (startTitel) startTitel.focus({ preventScroll: true });
      });
    });

    const teilenKnopf = wurzel.querySelector('[data-mhsys-finder-teilen]');
    if (teilenKnopf) {
      teilenKnopf.addEventListener('click', async () => {
        const f = [1, 2, 3, 4].map((n) => antworten[n] ? antworten[n].dataset.kuerzel : '').join('.');
        const url = `${location.origin}${location.pathname}?f=${encodeURIComponent(f)}`;
        const text = wurzel.dataset.teilenText || '';
        if (navigator.share) {
          try { await navigator.share({ text, url }); } catch (e) {}
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(url);
          const meldung = wurzel.querySelector('[data-mhsys-finder-kopiert]');
          if (meldung) { meldung.hidden = false; setTimeout(() => { meldung.hidden = true; }, 4000); }
        }
      });
    }

    wurzel.addEventListener('click', (e) => {
      /* Auch der Schnellkauf auf der Kachel zaehlt (3.24 C): der Klick laeuft hier durch, bevor das
         Formular absendet - assets/mhsys-quelle.js liest die Liste erst beim /cart/add */
      const kachel = e.target.closest('.mhsys-finder__treffer form[action*="/cart/add"] button') &&
        e.target.closest('.mhsys-finder__treffer .mhsys-kachel');
      const link = e.target.closest('.mhsys-finder__treffer a[href*="/products/"]') ||
        (kachel && kachel.querySelector('a[href*="/products/"]'));
      if (!link) return;
      const handle = link.pathname.split('/products/')[1];
      klickMerken(KLICKS, handle);
      if (istWeihnachtsFinder(wurzel)) klickMerken(KLICKS_WEIHNACHTEN, handle);
      melden('produkt', link.pathname);
    });

    wurzel.addEventListener('click', (e) => {
      if (e.target.closest('[data-mhsys-finder-b2b-link]')) melden('b2b_klick', '');
    });

    const mehrLink = wurzel.querySelector('[data-mhsys-finder-mehr]');
    if (mehrLink) {
      mehrLink.addEventListener('click', (e) => {
        e.preventDefault();
        const kern = ueberspringeDrei ? antworten[1].dataset.kern : (antworten[3] && antworten[3].dataset.kern);
        if (!kern) return;
        const von = antworten[4] ? antworten[4].dataset.preisVon : '';
        const bis = antworten[4] ? antworten[4].dataset.preisBis : '';
        let ziel = `/collections/${kern}?filter.v.availability=1`;
        if (von) ziel += `&filter.v.price.gte=${von}`;
        if (bis) ziel += `&filter.v.price.lte=${bis}`;
        location.href = ziel;
      });
    }

    function ausUrlOderSpeicher() {
      const params = new URLSearchParams(location.search);
      let kuerzel = null;
      let ausSpeicher = false;
      if (params.get('f')) kuerzel = params.get('f').split('.');
      else {
        try {
          const gespeichert = JSON.parse(sessionStorage.getItem(SPEICHER) || 'null');
          if (gespeichert && Date.now() - gespeichert.ts < MINUTEN30) { kuerzel = gespeichert.kuerzel; ausSpeicher = true; }
        } catch (e) {}
      }
      if (!kuerzel) return;
      wurzel.classList.remove('ist-einstieg');
      start.hidden = true;
      schritteBox.hidden = false;
      [1, 2, 3, 4].forEach((n, i) => {
        const code = kuerzel[i];
        if (!code) return;
        const feld = wurzel.querySelector(`[data-mhsys-finder-frage="${n}"] [data-kuerzel="${CSS.escape(code)}"]`);
        if (feld) { feld.checked = true; antworten[n] = feld; if (n === 1) ueberspringeDrei = !!feld.dataset.kern; }
      });
      const kernBereit = ueberspringeDrei ? antworten[1] : antworten[3];
      if (kernBereit) ergebnisZeigen(ausSpeicher);
      else {
        /* nur ein Teil vorbelegt (z. B. ?f=papa-opa von der Weihnachtsseite, Inhaber 26.09.2026): gleich die
           erste offene Frage zeigen, nicht die schon beantwortete */
        const offen = reihenfolge().find((nr) => !antworten[nr]);
        if (offen) rendereFrage(offen);
      }
    }

    ausUrlOderSpeicher();
  }

  document.querySelectorAll('[data-mhsys-finder]').forEach(init);
})();
